import { useEffect, useState } from 'react';
import { PrimaryButton } from '@/lib';
import { useOnboardingState, usePatchOnboarding } from '../queries';

export function DoneStep({ onFinish }: { onFinish: () => void }) {
  const state = useOnboardingState();
  const patch = usePatchOnboarding();
  const [stamped, setStamped] = useState(false);

  // Stamp completed_at once when the user lands on the Done step,
  // unless the wizard was already marked done previously.
  useEffect(() => {
    if (stamped) return;
    if (!state.data) return;
    if (state.data.completed_at) {
      setStamped(true);
      return;
    }
    patch.mutate(
      { completed_at: new Date().toISOString() },
      {
        onSuccess: () => setStamped(true),
        onError: () => setStamped(true),
      },
    );
  }, [state.data, stamped, patch]);

  const counts = (state.data?.steps ?? []).reduce<Record<string, number>>(
    (acc, s) => {
      acc[s.key] = s.count;
      return acc;
    },
    {},
  );

  return (
    <div className="flex flex-col gap-sp-4">
      <p className="text-fs-statement text-gray-900">All set — your tenant is provisioned.</p>
      <ul className="flex flex-col gap-sp-2 font-mono text-fs-meta text-gray-700">
        <li>Sites: {counts.site ?? 0}</li>
        <li>Assets: {counts.asset ?? 0}</li>
        <li>Sensors: {counts.sensor ?? 0}</li>
        <li>Assignments: {counts.assignment ?? 0}</li>
        <li>Invitations: {counts.invite ?? 0}</li>
      </ul>
      <PrimaryButton label="Open Attention dashboard" onClick={onFinish} />
    </div>
  );
}
